export default __webpack_public_path__ + "static/media/mint-popup-punk-animation.beb778d6.gif";